var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 6.78667C17.4532 5.08 19.6798 4 21.9998 4C26.1065 4 29.3332 7.22667 29.3332 11.3333C29.3332 16.3692 24.8073 20.4733 17.9501 26.6913L17.9332 26.7067L15.9998 28.4667L14.0665 26.72L14.0139 26.6722C7.17668 20.459 2.6665 16.3604 2.6665 11.3333C2.6665 7.22667 5.89317 4 9.99984 4C12.3198 4 14.5465 5.08 15.9998 6.78667ZM15.9998 24.8667L16.1332 24.7333C22.4798 18.9867 26.6665 15.1867 26.6665 11.3333C26.6665 8.66667 24.6665 6.66667 21.9998 6.66667C19.9465 6.66667 17.9465 7.98667 17.2532 9.81333H14.7598C14.0532 7.98667 12.0532 6.66667 9.99984 6.66667C7.33317 6.66667 5.33317 8.66667 5.33317 11.3333C5.33317 15.1867 9.51984 18.9867 15.8665 24.7333L15.9998 24.8667Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.471f85d9c5cfeaf627b11f95e968c59e.svg";
export { ForwardRef as ReactComponent };